import { clsx } from "clsx";
import type { ReactNode } from "react";
import { IconChevronRight } from "@tabler/icons-react";
import { Text } from "../typography";

export interface PreviewListRowProps {
  thumbnail: ReactNode;
  title: string;
  subtitle?: string;
  value?: string;
  actionLabel: string;
  onClick?: () => void;
  className?: string;
}

export function PreviewListRow({
  thumbnail,
  title,
  subtitle,
  value,
  actionLabel,
  onClick,
  className,
}: PreviewListRowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        "group flex w-full items-center gap-3 rounded-2xl border border-borderDefault bg-bgWhite px-4 py-3 text-left transition-colors hover:border-accentCyan",
        className,
      )}
    >
      <div className="size-12 shrink-0 overflow-hidden rounded-xl bg-bgLight">
        {thumbnail}
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <Text variant="bodyBold" tone="dark" className="truncate">
          {title}
        </Text>
        {subtitle ? (
          <Text variant="capsSm" tone="muted" inline className="truncate">
            {subtitle}
          </Text>
        ) : null}
        <div className="flex items-center justify-between">
          {value ? (
            <Text variant="bodyBold" tone="dark">
              {value}
            </Text>
          ) : <span />}
          <span className="flex items-center gap-0.5 text-textBody transition-colors group-hover:text-textDark">
            <Text variant="bodyBold" tone="inherit" inline>
              {actionLabel}
            </Text>
            <IconChevronRight size={16} />
          </span>
        </div>
      </div>
    </button>
  );
}

export default PreviewListRow;
